import { FormControlLabel, Switch } from '@mui/material';
import React from 'react';

type SwitchControllerProps = {
    name: string;
    label: string | React.ReactElement;
    checked: boolean;
    onChange: () => void;
};

const SwitchController = ({
    name,
    label,
    checked,
    onChange,
}: SwitchControllerProps) => (
    <FormControlLabel
        control={
            <Switch
                color="primary"
                name={name}
                checked={checked}
                onChange={onChange}
            />
        }
        label={label}
        labelPlacement="start"
    />
);

export default React.memo(SwitchController);
